// extracted by mini-css-extract-plugin
export default {"contacts":"Contact_contacts__eIOKd","contactsIcons":"Contact_contactsIcons__T+LeN"};